// @flow

import FroalaEditor from 'froala-editor';
import {postData} from 'app/utils/request';

import {type ACLType} from 'app/utils/fineuploader';

type SettingsType = {
  uploadURL?: string,
  successEndpoint: string,
  requestEndpoint: string,
  signatureEndpoint: string,
  accountId: number,
  accessKey: string,
  objACL: ACLType,
  bucket: string,
  mediaURL: string,
  objParams: {[string]: any},
};

// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.awsUploadSucessNotifier = function (editor) {
  function notifyUploadBuilder(config: SettingsType) {
    const successURL = config.successEndpoint;

    function extractKeyFromUploadedToS3Event(url?: string, key?: string) {
      if (key != null && key !== '') {
        return key;
      }

      if (url != null && url !== '') {
        let cleanedUrl = decodeURIComponent(url).replace(config.requestEndpoint, '')
        if (cleanedUrl.startsWith('/')) {
          cleanedUrl = cleanedUrl.replace('/', '')
        }
        return cleanedUrl;
      }
    }

    return function notifyUpload(url, key) {
      return postData(successURL, {key: extractKeyFromUploadedToS3Event(url, key)});
    };
  }

  // eslint-disable-next-line no-underscore-dangle
  function _init() {
    if (editor.opts.imageUploadToS3 !== false) {
      editor.events.on(
        'image.uploadedToS3',
        notifyUploadBuilder(editor.opts.imageUploadToS3)
      );
    }

    if (editor.opts.videoUploadToS3 !== false) {
      editor.events.on(
        'video.uploadedToS3',
        notifyUploadBuilder(editor.opts.videoUploadToS3)
      );
    }
  }

  // Methods visible outside the plugin.
  return {_init};
};
